import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}
export const Container = styled.div<ContainerProps>`
  background: #d2d2d2;
  border-radius: 10px;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;

  border: 2px solid #666360;
  color: #f4ede8;

  transition: border-color 0.2s, color 0.2s;
  input {
    background: transparent;
    flex: 1;
    border: 0;
    color: #666360;
    &::placeholder {
      color: #666360;
    }
  }
  & + div {
    margin-top: 8px;
  }
  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}
  ${props =>
    props.isFocused &&
    css`
      color: #8c4e9a;
      border-color: #3D8C4C;
    `}
    ${props =>
    css`
      color: #3D8C4C;
    `}




  svg {
    margin-right: 16px;

    ${props =>
      props.isFilled &&
      css`
        color: #8c4e9a;
        border-color: #8c4e9a;
      `}
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }
  span {
    background: #c53030;
    color: #fff;
    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
